import { Component, OnInit ,Input, Inject} from '@angular/core';
import * as braintree from 'braintree-web';
import { BraintreeService } from '../../../../shared/services/braintree/braintree.service';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '../../../../core/services/loader/loader.service';

interface ResponseApi {
  StatusCode: number;
  Message: string;
}

@Component({
  selector: 'app-braintree-payment',
  templateUrl: './braintree-payment.component.html',
  styleUrls: ['./braintree-payment.component.scss']})



export class BraintreePaymentComponent implements OnInit {
  amount: string;   
  hostedFieldsInstance: braintree.HostedFields;
  cardholdersName: string;
  cardholdersemail: string;
  UserId: any;
  cardNumber: boolean;
  Cvv: boolean;
  ExpiryDate: boolean;
  cardholderEmailId: boolean;
  constructor(private brainTreeService: BraintreeService,
    private loader: LoaderService,private notificationService: NotificationService, public dialogRef: MatDialogRef<BraintreePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {
    this.UserId = localStorage.getItem('userId');
    this.amount = data;
  }
  ngOnInit() {
    this.cardNumber= false;
    this.Cvv= false;
    this.ExpiryDate= false;
    this.createBraintreeUI();
  }

  createBraintreeUI() {
    this.loader.show();
    braintree.client.create({
      authorization: localStorage.getItem('clientToken'),
    }).then((clientInstance) => {
      braintree.hostedFields.create({
        client: clientInstance,
        styles: {
          // Override styles for the hosted fields
        },

        // The hosted fields that we will be using
        // NOTE : cardholder's name field is not available in the field options
        // and a separate input field has to be used incase you need it
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '1111 1111 1111 1111'
          },
          cvv: {
            selector: '#cvv',
            placeholder: '111'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: 'MM/YY'
          }
        }
      
      }).then((hostedFieldsInstance) => {
        this.loader.hide();
        this.hostedFieldsInstance = hostedFieldsInstance;

        //hostedFieldsInstance.on('focus', (event) => {
        //  debugger
        //  const field = event.fields[event.emittedBy];
        //  const label = this.findLabel(field);
        //  label.classList.remove('filled'); // added and removed css classes
        //  // can add custom code for custom validations here
        //});

        hostedFieldsInstance.on('blur', (event) => {         
          const field = event.fields[event.emittedBy];
          const label = this.findLabel(field); // fetched label to apply custom validations
          if (field.container.id == "card-number") {
            if (field.isEmpty == false)
              this.cardNumber = true;
            else
              this.cardNumber = false;
          } else if (field.container.id == "expiration-date") {
            if (field.isEmpty == false)
              this.ExpiryDate = true;
            else
              this.ExpiryDate = false;

          } else if (field.container.id == "cvv") {
            if (field.isEmpty == false)
              this.Cvv = true;
            else
              this.Cvv = false;

          }

          // can add custom code for custom validations here
        });

        //hostedFieldsInstance.on('empty', (event) => {
        //  debugger
        //  const field = event.fields[event.emittedBy];
        //  // can add custom code for custom validations here
        //});

        //hostedFieldsInstance.on('validityChange', (event) => {
        //  debugger
        //  const field = event.fields[event.emittedBy];
        //  const label = this.findLabel(field);
        //  if (field.isPotentiallyValid) { // applying custom css and validations
        //    label.classList.remove('invalid');
        //  } else {
        //    label.classList.add('invalid');
        //  }
        //  if (field.container.id == "card-number") {
        //    if (field.isPotentiallyValid == false)
        //      this.cardNumber = true;
        //    else
        //      this.cardNumber = false;
        //  } else if (field.container.id == "expiration-date") {
        //    if (field.isPotentiallyValid == false)
        //      this.ExpiryDate = true;
        //    else
        //      this.ExpiryDate = false;

        //  } else if (field.container.id == "cvv") {
        //    if (field.isPotentiallyValid == false)
        //      this.Cvv = true;
        //    else
        //      this.Cvv = false;

        //  }
         
        //  // can add custom code for custom validations here
        //});
      });
    });
  }

  // Tokenize the collected details so that they can be sent to your server
  // called from the html when the 'Pay' button is clicked
  tokenizeUserDetails() {  
    this.loader.show();
    if (this.cardholdersemail == undefined || this.cardholdersemail == "") {
      this.notificationService.error('Email is required', 'Error');
      this.loader.hide();
      event.preventDefault();
      return false;
    }    
    this.hostedFieldsInstance.tokenize({ cardholderName: this.cardholdersName }).then((payload) => {
    
      this.brainTreeService.submitNoncePayment({
        nonce: payload.nonce,
        userid: this.UserId,
        amount: this.amount,
        email: this.cardholdersemail,
      }).subscribe((res: any) => {
        // tslint:disable-next-line:no-shadowed-variable
        const data: ResponseApi = res;
        if (data.StatusCode === 200) {
          this.loader.hide();
          this.notificationService.success('Payment Successfully completed ', 'Success');
          this.dialogRef.close({
            data: data
          });

        } else {
          this.loader.hide();
          this.dialogRef.close({
            data: "error"
          });
          this.notificationService.error(data.Message, 'Error');
        }
      });
      // submit payload.nonce to the server from here    
    }).catch((error) => {    
      this.notificationService.error(error.message + ','+'invalid field '+error.details.invalidFieldKeys[0],'Error')
      console.log(error);
      this.loader.hide();
      // perform custom validation here or log errors    
    });
  }



  // Fetches the label element for the corresponding field
  findLabel(field: braintree.HostedFieldsHostedFieldsFieldData) {
    return document.querySelector('.hosted-field--label[for="' + field.container.id + '"]');
  }
}
